<template>
  <b-sidebar
    right
    shadow
    backdrop
    v-model="showSidebar"
    width="90%"
    @change="visibleChanged"
    no-header
    prop
  >
    <form-list
      :prms="prms"
      @on-form-selected="$emit('on-form-selected', $event)"
      @on-close="visibleChanged(false)"
    />
  </b-sidebar>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    formList: () => ({
      component: import("@/views/modules/form/list"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    prms: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      taskObj: {
        loaded: false,
        columns: [],
        task: {}
      },
      showSidebar: false,
      nestedSidebar: false,
      idNested: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.showSidebar = true;
      //console.log('this.prms', this.prms);
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-close");
      }
    }
  }
};
</script>

<style></style>
